import React, { Fragment } from "react";
import "./scrollicon.css";
const ScrollIcon = () => {
  return (
    <Fragment>
      <div class="page-wrap">
        <section class="example example--2">
          <span class="scroll-icon">
            <span class="scroll-icon__dot"></span>
          </span>
        </section>
      </div>
    </Fragment>
  );
};

export default ScrollIcon;
